import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SupportRoutingModule } from './support-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GeneralModule } from '../general/general.module';
import { GeneralTicketComponent } from './general-ticket/general-ticket.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { SupportFormComponent } from './support-form/support-form.component';
import { PipesModule } from '../pipes/pipes.module';
import { DocumentTicketComponent } from './document-ticket/document-ticket.component';
import { NameTicketComponent } from './name-ticket/name-ticket.component';
import { TechnicalIssueTicketComponent } from './technical-issue-ticket/technical-issue-ticket.component';
import { DepositTicketComponent } from './deposit-ticket/deposit-ticket.component';
import { BankTicketComponent } from './bank-ticket/bank-ticket.component';
import { PhoneTicketComponent } from './phone-ticket/phone-ticket.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatTooltipModule} from "@angular/material/tooltip";
import { OtpTicketComponent } from './otp-ticket/otp-ticket.component';
import { EmailChangeTicketComponent } from './email-change-ticket/email-change-ticket.component';
import { ResidentialChangeTicketComponent } from './residential-change-ticket/residential-change-ticket.component'
import { EscalationTicketComponent } from './escalation-ticket/escalation-ticket.component';
@NgModule({
  declarations: [
    GeneralTicketComponent,
    SupportFormComponent,
EscalationTicketComponent,
    DocumentTicketComponent,
    NameTicketComponent,
    TechnicalIssueTicketComponent,
    DepositTicketComponent,
    BankTicketComponent,
    PhoneTicketComponent,
    OtpTicketComponent,
    EmailChangeTicketComponent,
    ResidentialChangeTicketComponent
  ],
  imports: [
    CommonModule,
    SupportRoutingModule,
    ReactiveFormsModule,
    NgSelectModule,
    GeneralModule,
    BrowserAnimationsModule, 
    MatTooltipModule,
    PipesModule,
    FormsModule
  ],
  exports: [
    SupportFormComponent,
    EscalationTicketComponent
  ]
})
export class SupportModule { }
